import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'
import {
  Cell,
  DataBlock,
  Divider,
  Expander,
  ExpanderContent,
  ExpanderHeader,
  Grid,
  ResponsiveTableRow,
  H5,
} from '@fs/zion-ui'
import { DmcResponsiveTable } from '../../../common/DmcResponsiveTable'

export default function OdmAudits({ audits }) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(true)

  return (
    <>
      <Divider marginY="nano" />
      <Expander open={open} setOpen={setOpen}>
        <ExpanderHeader>
          <H5>{t('odm.audit', 'Auditing Search')}</H5>
        </ExpanderHeader>
        <ExpanderContent>
          <Divider marginY="nano" />
          {audits && (
            <DmcResponsiveTable
              atSizeColumns={{
                default: {
                  labels: [
                    t('odm.audit.collection', 'Collection'),
                    t('odm.audit.rfn', 'RFN'),
                    t('odm.audit.table', 'Table'),
                    t('odm.audit.column', 'Column'),
                    t('odm.audit.type', 'Type'),
                    t('odm.audit.date', 'Date'),
                  ],
                },
              }}
              totalColumnCount={6}
            >
              {audits.map((audit) => {
                return (
                  <ResponsiveTableRow
                    key={`${audit.rfn}-${audit.date}`}
                    column1={audit.collection}
                    column2={audit.rfn}
                    column3={audit.table}
                    column4={audit.column}
                    column5={audit.type}
                    column6={audit.date}
                  >
                    <Grid>
                      <Cell columns={2}>
                        <DataBlock heading={t('odm.audit.nameId', 'Name ID')} data={audit.nameId} />
                      </Cell>
                      <Cell columns={2}>
                        <DataBlock heading={t('odm.audit.username', 'Username')} data={audit.username} />
                      </Cell>
                      <Cell columns={4}>
                        <DataBlock heading={t('odm.audit.oldInfo', 'Old Information')} data={audit.oldInfo || '---'} />
                      </Cell>
                      <Cell columns={4}>
                        <DataBlock heading={t('odm.audit.newInfo', 'New Information')} data={audit.newInfo || '---'} />
                      </Cell>
                      <Cell columns={8}>
                        <DataBlock heading={t('odm.audit.reason', 'Reason')} data={audit.reason || '---'} />
                      </Cell>
                    </Grid>
                  </ResponsiveTableRow>
                )
              })}
            </DmcResponsiveTable>
          )}
          {!audits && <p>{t('odm.noAudit', 'No Audit Information')}</p>}
          <Divider marginY="nano" />
        </ExpanderContent>
      </Expander>
    </>
  )
}
